import React, { useState, useEffect, useCallback } from 'react';
import styles from './index.module.sass';
import SectionTitle from '../../SectionTitle';
import CircularProgress from '@mui/material/CircularProgress';
import AlertConfirm from '../AlertConfirmTerravoucher';
import { useTranslation } from 'react-i18next';
import Alert from '../../Alert';
import GetPremiosTerraVoucher from '../../Queries/GetPremiosTerraVoucher';
import GetConsumirTerraVoucher from '../../Queries/GetConsumirTerraVoucher';

const TerraVoucher = (props) => {
  const { device, getCookie, webservice } = props;
  const { screenSize } = device;
  const [loading, setloading] = useState(false);
  const [data, setdata] = useState({});
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [voucher, setvoucher] = useState('');
  const { t } = useTranslation('terravoucher');
  const [optionvoucher, setoptionvoucher] = useState({
    ALVOLANTE: false,
    BASESVIAJE: false,
    CLUBELITE: false,
    TUDECIDES: false,
    TOUREJECUT: false,
  });

  function submit(voucherSelect) {
    setvoucher(voucherSelect);
    setAlertText(t('alertText') + voucherSelect + '?');
    setOpen(true);
  }

  useEffect(() => {
    setloading(true);
    async function Show() {
      const response = await GetPremiosTerraVoucher();
      const { typeMessage = 'error', message = '', ListadoPremios = [] } = response;

      if (typeMessage === 'success') {
        setdata(ListadoPremios);
        let v1 = false;
        let v2 = false;
        let v3 = false;
        let v4 = false;
        let v5 = false;

        for (let index = 0; index < ListadoPremios.length; index++) {
          switch (ListadoPremios[index].codigo.trim()) {
            case 'ALVOLANTE':
              v1 = true;
              break;
            case 'BASESVIAJE':
              v2 = true;
              break;
            case 'CLUBELITE':
              v3 = true;
              break;
            case 'TUDECIDES':
              v4 = true;
              break;
            case 'TOUREJECUT':
              v5 = true;
              break;

            default:
              break;
          }
          setoptionvoucher({
            ALVOLANTE: v1,
            BASESVIAJE: v2,
            CLUBELITE: v3,
            TUDECIDES: v4,
            TOUREJECUT: v5,
          });
        }
      } else {
        if (message === 'X') {
          setAlertText(t('notFound'));
          setOpenAlert(true);
        } else {
          setAlertText(t('complete'));
          setOpenAlert(true);
        }
      }
      setloading(false);
    }
    Show();
  }, [getCookie, webservice, t]);

  const liberateTerra = useCallback(async () => {
    setloading(true);
    setOpen(false);
    setvoucher(voucher);
    const response = await GetConsumirTerraVoucher(getCookie('usuarioOk'), voucher);
    const { typeMessage = 'error', message = '' } = response;

    if (typeMessage === 'success') {
      setAlertText(t('liberate') + voucher);
      setOpenAlert(true);
      setdata({});
    } else {
      setAlertText(message);
      setOpenAlert(true);
    }
    setloading(false);
  }, [getCookie, voucher, t]);

  return (
    <div id={[screenSize]} className={styles.terraVoucher}>
      <Alert open={openAlert} setOpen={setOpenAlert} title={t('alertTitle')} text={alertText} />
      <SectionTitle
        title='Terravoucher'
        subtitle=''
        subtitleGray={t('messageTitle')}></SectionTitle>
      <AlertConfirm
        open={open}
        setOpen={setOpen}
        title={t('titleMessage')}
        text={alertText}
        setvoucher={setvoucher}
        callback={liberateTerra}
      />
      {!loading ? (
        <div className={styles.container}>
          {data.length > 0 ? (
            <>
              <div className={`${styles.option} ${styles[screenSize]}`}>
                {optionvoucher.BASESVIAJE === true ? (
                  <div className={`${styles.cupon} ${styles[screenSize]}`}>
                    <div className={styles.divButton1}>
                      <div className={`${styles.label} ${styles[screenSize]}`}>
                        <label>{t('v1')}</label>
                      </div>
                      <div className={styles.button} onClick={() => submit('BASESVIAJE')}>
                        <div>{t('titleButton')}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {optionvoucher.ALVOLANTE === true ? (
                  <div className={`${styles.cupon} ${styles[screenSize]}`}>
                    <div className={styles.divButton2}>
                      <div className={`${styles.label} ${styles[screenSize]}`}>
                        <label>{t('v2')}</label>
                      </div>
                      <div className={styles.button} onClick={() => submit('ALVOLANTE')}>
                        <div>{t('titleButton')}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {optionvoucher.TOUREJECUT === true ? (
                  <div className={`${styles.cupon} ${styles[screenSize]}`}>
                    <div className={styles.divButton3}>
                      <div className={`${styles.label} ${styles[screenSize]}`}>
                        <label>{t('v3')}</label>
                      </div>
                      <div className={styles.button} onClick={() => submit('TOUREJECUT')}>
                        <div>{t('titleButton')}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className={`${styles.option} ${styles[screenSize]}`}>
                {optionvoucher.CLUBELITE === true ? (
                  <div className={`${styles.cupon} ${styles[screenSize]}`}>
                    <div className={styles.divButton4}>
                      <div className={`${styles.label} ${styles[screenSize]}`}>
                        <label>{t('v4')}</label>
                      </div>
                      <div className={styles.button} onClick={() => submit('CLUBELITE')}>
                        <div>{t('titleButton')}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {optionvoucher.TUDECIDES === true ? (
                  <div className={`${styles.cupon} ${styles[screenSize]}`}>
                    <div className={styles.divButton5}>
                      <div className={`${styles.label} ${styles[screenSize]}`}>
                        <label>{t('v5')}</label>
                      </div>
                      <div className={styles.button} onClick={() => submit('TUDECIDES')}>
                        <div>{t('titleButton')}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <div className={styles.cupon2}>
                  <div className={styles.divButtonEmpty}>&nbsp;</div>
                </div>
              </div>
            </>
          ) : (
            <div className={styles.subtitle}>{alertText}</div>
          )}
        </div>
      ) : (
        <div className={styles.container}>
          <CircularProgress className={styles.loading} />
        </div>
      )}
    </div>
  );
};
export default TerraVoucher;
